var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":"primary lighten-2","size":"32"}},[_c('span',{staticClass:"white--text text-caption font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("fullnameToInitials")(_vm.name))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }